<template>
  <main id="set-new-password-page" class="page-container">
    <!-- Messaggi di errore/successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Contenitore del form -->
    <div id="set-password-form">
      <!-- Form -->
      <form class="set-password-form" @submit.prevent="resetPassword">
        <h1>Reimposta Password</h1>
        <!-- Prima password + toggle -->
        <div class="password-field">
          <input
            id="set-password"
            :type="showNewPassword ? 'text' : 'password'"
            placeholder="Nuova password"
            v-model="newPassword"
            required
          />
          <!-- Bottone occhio/lucchetto -->
          <button
            type="button"
            class="toggle-password-button"
            @click="toggleNewPassword"
          >
            <!-- Se showNewPassword è false, mostra icona occhio chiuso. Altrimenti, occhio aperto. -->
            <i v-if="!showNewPassword" class="fa-solid fa-eye-slash"></i>
            <i v-else class="fa-solid fa-eye"></i>
          </button>
        </div>

        <!-- Seconda password + toggle -->
        <div class="password-field">
          <input
            id="set-password2"
            :type="showNewPassword2 ? 'text' : 'password'"
            placeholder="Conferma password"
            v-model="newPassword2"
            required
          />
          <button
            type="button"
            class="toggle-password-button"
            @click="toggleNewPassword2"
          >
            <i v-if="!showNewPassword2" class="fa-solid fa-eye-slash"></i>
            <i v-else class="fa-solid fa-eye"></i>
          </button>
        </div>

        <!-- [sc-48692] Codice d'invito: lo genera l'amministratore dell'azienda
             e lo dà a voce. Il link da solo non basta. -->
        <template v-if="invito">
          <div class="password-field">
            <input
              id="invite-code"
              v-model.trim="code"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              placeholder="Codice di 6 cifre"
              required
            />
          </div>
          <!-- [sc-48351] Il primo amministratore di un'azienda PLUS creata
               dalla console lo riceve da Liberotratto. -->
          <p class="invite-code-hint">
            Il codice te lo dà a voce l'amministratore della tua azienda, o
            Liberotratto se sei il primo ad accedere.
          </p>
        </template>

        <!-- Bottone invio -->
        <button
          id="reset-button"
          type="submit"
          :disabled="
            !newPassword ||
            !newPassword2 ||
            newPassword !== newPassword2 ||
            (invito && !codiceValido)
          "
        >
          REIMPOSTA PASSWORD
        </button>
      </form>
    </div>
  </main>
</template>

<script>
export default {
  name: "SetNewPasswordPage",
  data() {
    return {
      newPassword: "",
      newPassword2: "",
      errorMessage: "",
      successMessage: "",
      /* Variabili per mostrare/nascondere le password */
      showNewPassword: false,
      showNewPassword2: false,
      // [sc-48692] Token letto all'arrivo, e codice d'invito.
      token: "",
      invito: false,
      code: "",
    };
  },
  computed: {
    // [sc-48692] Il codice com'è stato scritto, spazi tolti: la stessa regola
    // di `normalizzaCodice` nell'API. Niente maxlength sul campo: taglierebbe
    // prima di togliere gli spazi, e un codice incollato con uno spazio davanti
    // resterebbe di 5 cifre.
    codiceNormalizzato() {
      return String(this.code || "").replace(/\s+/g, "");
    },
    codiceValido() {
      return /^\d{6}$/.test(this.codiceNormalizzato);
    },
  },
  created() {
    // [sc-48692] Il token vale come una chiave finché non viene usato: si legge
    // una volta e si toglie dall'indirizzo, così non resta nella cronologia né
    // in una schermata condivisa. Ricaricando la pagina si perde, e si riapre
    // il collegamento dall'email.
    this.token = String(this.$route.query.token || "");
    // Il link d'invito lo dice: la pagina chiede anche il codice.
    this.invito = this.$route.query.invito === "1";
    if (this.$route.query.token) {
      this.$router.replace({ query: {} });
    }
  },
  methods: {
    toggleNewPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
    toggleNewPassword2() {
      this.showNewPassword2 = !this.showNewPassword2;
    },
    async resetPassword() {
      try {
        if (this.newPassword !== this.newPassword2) {
          this.errorMessage = "Le password non corrispondono!";
          this.$toast.error(this.errorMessage);
          return;
        }
        const payload = { password: this.newPassword };
        // [sc-48692] Il codice parte solo per un invito: al recupero password
        // di un account attivo non serve.
        if (this.invito) payload.code = this.codiceNormalizzato;
        const response = await this.$axios.post(
          `/auth/reset-password?token=${encodeURIComponent(this.token)}`,
          payload
        );
        if (response.status === 200) {
          this.successMessage =
            response.data?.details || "Password reimpostata con successo!";
          this.$toast.success(this.successMessage);
          this.errorMessage = "";
        }
        // Reindirizza dopo 2 secondi
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
      } catch (error) {
        // [sc-48692] Un problema col codice non si risolve chiedendo un altro
        // link: si resta qui, col campo in vista. Vale anche per l'invito
        // annullato (INVITE_CODE_LOCKED): il messaggio dice cosa fare.
        const codiceErrore = error.response?.data?.code;
        if (
          typeof codiceErrore === "string" &&
          codiceErrore.startsWith("INVITE_CODE_")
        ) {
          this.invito = true;
          this.errorMessage = error.response.data.message;
          this.$toast.error(this.errorMessage);
          return;
        }
        console.error("Errore reimpostazione password: ", error);
        // Se lo status è 400 => token scaduto o invalido
        if (error.response?.status === 400) {
          this.errorMessage =
            error.response?.data?.details ||
            "Token scaduto o non valido. Richiedi nuovamente il link di recupero password.";
          this.$toast.error(this.errorMessage);
          // Reindirizza dopo 2 secondi a /auth/verify-email
          setTimeout(() => {
            this.$router.push("/login/verify-email");
          }, 2000);
        } else {
          // Altri errori generici
          this.errorMessage =
            error.response?.data?.error ||
            "Errore durante la reimpostazione della password.";
          this.$toast.error(this.errorMessage);
        }
      }
    },
  },
};
</script>

<style src="@/css/SetNewPassword.css"></style>
